import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "opening",
  "use": "opening-usage",
  "viewBox": "0 0 15.5 28.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.5 28.1\" id=\"opening\"><path d=\"M15.5 0L.1 8.8 0 27l7.1-4.8v6l8.4-10.9V0zM1.1 24.8V9.4l13-7.6L7 11.7v9l-5.9 4.1zm13.3-8l-6.1 7.9V12.1l6.1-8.6v13.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol